import { T_SectionInfoMap } from '../types/T_Profile';

export const profileInfo: T_SectionInfoMap = {
  referrals: {
    titleKey: 'profile.sections.referrals.title',
    variant: 'referrals',
    emptyState: {
      titleKey: 'profile.sections.referrals.emptyState.title',
      textKey: 'profile.sections.referrals.emptyState.text',
      actionTextKey: ''
    }
  }
};
